module.exports = __webpack_public_path__ + "static/media/branch-black.8973cd04.svg";